import {
  Box,
  Text,
  Flex,
  Grid,
  VStack,
  Divider,
  Input,
  Button,
} from "@chakra-ui/react";
import {
  IconBrandFacebook,
  IconBrandTwitter,
  IconBrandLinkedin,
  IconBrandInstagram,
  IconPhone,
  IconMail,
  IconMapPin,
  IconBrandGmail,
} from "@tabler/icons-react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <Box bg="gray.900" color="white" py={12} px={4}>
      <Box maxW="1200px" mx="auto">
        <Grid
          templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }}
          gap={8}
          mb={8}
        >
          {/* Company Info */}
          <Box>
            <Text fontSize="xl" fontWeight="bold" color="#B67300" mb={4}>
              Lions Forge Contracting
            </Text>
            <Text mb={4} color="gray.300">
              Trusted by clients for quality work, timely delivery and strong partnerships.
            </Text>
           <Flex gap={4}>
  {[
    // { Icon: IconBrandFacebook, link: "https://facebook.com" },
    // { Icon: IconBrandTwitter, link: "https://twitter.com" },
    { Icon: IconBrandLinkedin, link: "https://www.linkedin.com/company/lionsforgecontracting/" },
    { Icon: IconBrandInstagram, link: "https://www.instagram.com/lionsforgecontracting?igsh=MTF5dTM4MDNlMG9xdA%3D%3D&utm_source=qr" },
    { Icon: IconBrandGmail, link: "mailto:info@lionsforgecontracting.ca" }
  ].map(({ Icon, link }, i) => (
    <Box
      as="a"
      href={link}
      key={i}
      target="_blank" // opens in new tab
      rel="noopener noreferrer"
      bg={i >= 4 ? "#B67300" : "transparent"} // Gmail + last icons with background
      p={i >= 4 ? 2 : 0}
      borderRadius="full"
      cursor="pointer"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Icon size={i >= 4 ? 30 : 20} color={i >= 4 ? "white" : "gray"} />
    </Box>
  ))}
</Flex>

          </Box>

          {/* Quick Links */}
          <Box>
            <Text fontSize="lg" fontWeight="semibold" mb={4}>
              Quick Links
            </Text>
            <VStack align="start" spacing={2}>
            <Link to="/">
              <Text color="gray.300" cursor="pointer" _hover={{ color: "white" }}>
                Home
              </Text>
            </Link>
            
            <Link to="services/demolition">
             <Text color="gray.300" cursor="pointer" _hover={{ color: "white" }}>
                Services
              </Text>
            </Link>
             <Link to="about">
 <Text color="gray.300" cursor="pointer" _hover={{ color: "white" }}>
                About Us
              </Text>
             </Link>
             <Link to="contact">
               <Text color="gray.300" cursor="pointer" _hover={{ color: "white" }}>
                Contact
              </Text>
             </Link>
            
              {/* <Text color="gray.300" cursor="pointer" _hover={{ color: "white" }}>
                Careers
              </Text> */}
            </VStack>
          </Box>

          {/* Contact Info */}
          <Box>
            <Text fontSize="lg" fontWeight="semibold" mb={4}>
              Contact Info
            </Text>
            <VStack align="start" spacing={3}>
              <Flex align="center" gap={2}>
                <IconPhone size={16} color="#B67300" />
                <Text color="gray.300">+1 (604) 712-5656</Text>
              </Flex>
              <Flex align="center" gap={2}>
                <IconMail size={16} color="#B67300" />
                <Text color="gray.300">info@lionsforgecontracting.ca</Text>
              </Flex>
              {/* <Flex align="start" gap={2}>
                <IconMapPin size={16} color="#B67300" />
                <Text color="gray.300">
                  123 Business Ave, Suite 100, City, State 12345
                </Text>
              </Flex> */}
            </VStack>
          </Box>

          {/* Newsletter */}
          <Box>
            <Text fontSize="lg" fontWeight="semibold" mb={4}>
              Newsletter
            </Text>
            <Text color="gray.300" mb={4}>
              Subscribe to get updates on our services and offers.
            </Text>
            <VStack spacing={3}  zIndex="0"  position="relative"

  boxShadow="none">
              <Input
                placeholder="Enter your email"
                bg="gray.800"
                border="1px solid"
                borderColor="gray.600"
                color="white"
                _placeholder={{ color: "gray.400" }}
                zIndex={0}
              />
              <Button bg="#B67300" color="white" w="full" size="sm" _hover={{ bg: "#e64400" }}>
                Subscribe
              </Button>
            </VStack>
          </Box>
        </Grid>

        <Divider borderColor="gray.700" mb={6} />

        <Flex
          direction={{ base: "column", md: "row" }}
          justify="space-between"
          align="center"
          gap={4}
        >
          <Text color="gray.400">© 2025  Lions Forge contracting. All rights reserved.</Text>
          <Flex gap={6}>
            <Text color="gray.400" cursor="pointer" _hover={{ color: "white" }}>
              Privacy Policy
            </Text>
            <Text color="gray.400" cursor="pointer" _hover={{ color: "white" }}>
              Terms of Service
            </Text>
          </Flex>
           <Text color="gray.400" cursor="pointer" _hover={{ color: "white" }}>
              Powered by Gotech Digi
            </Text>
        </Flex>
      </Box>
    </Box>
  );
};
